import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DialogComponent } from '@farris/ui-dialog';
import { SearchBoxComponent, SearchFieldsComponent } from '@farris/ui-search-box';
import { LookupGridComponent } from '../lookup-grid.component';
import { SearchBarMode } from '../lookup-displaytype';

@Component({
    selector: '[lookup-filter-bar]',
    template: `
    <div class="d-flex flex-row">
        <farris-search-fields #searchfields [fields]="filterFields" class="mr-2 f-utils-fill"  
        *ngIf="filterFields && filterFields.length && (viewType == 'both' || viewType=== 'onlyfield')" 
        (conditionChange)="onConditionChange($event, false)"></farris-search-fields>

        <div style="min-width:40%;" class="d-flex flex-row" [class.w-100]="!filterFields || !filterFields.length" [style.maxWidth]="filterFields && filterFields.length?'70%': '100%'">
            <farris-search-box #searchbox [fields]="fields" [useAnyField]="searchAnyField"
            (conditionChange)="onConditionChange($event, true)" class="f-cmp-inputgroup f-utils-fill" 
            *ngIf="(viewType == 'both' || viewType=== 'onlyinput')" (escHandler)="onEsc($event)"></farris-search-box>
            <span class="f-icon f-icon-remove clear-search-fields" 
                [ngStyle]="((textConditions && textConditions.length) || (fieldConditons && fieldConditons.length)) ? { }: {opacity: '0.3',pointerEvents: 'none'}"
                (click)="onClearConditions($event)" title="{{ 'lookup.clearAllConditions' | locale }}" style="min-width:28px;border: 0;"></span>
        </div>
    </div>
    `
})

export class LookupFilterBarComponent implements OnInit, OnChanges, AfterViewInit {

    fields = [];
    filterFields = [];
    @Input() searchAnyField = true;
    @Input() columns = [];
    @Input() viewType: SearchBarMode = SearchBarMode.both;
    @Input() isNav = false;

    @Input() searchFields = [];

    @Output() conditionsChange = new EventEmitter();

    @ViewChild('searchbox') searchboxRef: SearchBoxComponent;
    @ViewChild('searchfields') searchfieldsRef: SearchFieldsComponent;

    textConditions = [];
    fieldConditons = [];
    

    dialogRef: DialogComponent;
    private el: ElementRef;
    constructor(private injector: Injector, private cd: ChangeDetectorRef, private lookIns: LookupGridComponent) {
        this.dialogRef = this.injector.get(DialogComponent, null);
        this.el = this.injector.get(ElementRef);
    }

    ngOnInit() {
        this.searchFields = this.searchFields || [];
        this.convertColumnsToSearchFields();

        if(this.dialogRef && this.searchboxRef) {
            this.dialogRef.moving.subscribe(() => {
                this.searchboxRef.updateShadowBoxPosition();
            })
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.columns && !changes.columns.isFirstChange()) {
            this.convertColumnsToSearchFields();
            setTimeout(() => {
                this.initSearchValue();
            }, 100)
        }
    }

    ngAfterViewInit() {
    }

    private initSearchValue() {
        if (this.lookIns._searchState && !this.isNav && this.searchboxRef) {
            const { field, value} = this.lookIns._searchState;
            if (field === '*' && value != '' && value !== null && value!== undefined) {
                const alltitle = this.lookIns.localService.getValue('lookup.anyFields')
                const _conditions = [{ code: '*', name: alltitle, value }];
                this.searchboxRef.setValue(_conditions, false);
                this.textConditions = this.searchboxRef.expandStarFieldToAllFields();
            }
        }
    }

    private converColumnToFilterField(n: any) {
        const t: any = {};
        t.id = n.field;
        t.labelCode = n.field;
        t.code = n.fieldPath;
        t.name = n.title;
        const options = n.formatter ? n.formatter.options : null;
        // æ°å­
        if (n.fieldType === 'NumericType') {
            const _options = {...(options || {})};
            n.precision = n.precision || 0;
            _options.precision = _options.precision || 0;
            if (n.precision != _options.precision) {
                _options.precision = n.precision;
            }

            t.control = Object.assign({ 
                "controltype": "number", 
                "bigNumber": false, 
                "placeHolder": 'è¯·è¾å¥æ°å­', 
                single: true 
            }, _options);
            t.beginPlaceHolder = "å¼å§æ°å¼";
            t.endPlaceHolder = "ç»ææ°å¼";
        }
        // æä¸¾
        if (n.fieldType === 'EnumType') {
            t.control = {
                "controltype": "enum",
                "enumValues": n.formatter.options.data,
                single: true
            };
        }

        // å¸å°
        if (n.fieldType === 'BooleanType') {
            let trueText = options ? options.trueText || 'True' : 'True';

            let falseText = options ? options.falseText || 'False' : 'False';
            t.control = {
                controltype: 'dropdown',
                enumValues: [
                    { value: 1, name: trueText },
                    { value: 0, name: falseText },
                ],
                single: true
            };
        }

        // æ¥æ
        if (n.fieldType === "DateType" || n.fieldType === 'DateTimeType') {

            let dateFormat = 'yyyy-MM-dd';
            let showTime = false;
            let showType = '1';
            if (options) {
                if (options.format) {
                    dateFormat = options.format;
                }
            }
            if (n.fieldType === 'DateTimeType') {
                showTime = true;
            }
            if (dateFormat === 'yyyy') {
                showType = '2';
            }
            if (dateFormat === 'yyyy-MM') {
                showType = '3';
            }
            t.control = {
                "controltype": "datetime",
                "placeholder": "è¯·éæ©æ¥æ",
                single: true,
                dateFormat,
                showTime,
                showType
            };
        }
        return t;
    }

    private convertColumnsToSearchFields() {
        if (this.columns && this.columns.length) {
            this.fields = this.columns.filter(n => n.fieldType && (n.fieldType === 'StringType' || n.fieldType === 'TextType')).map(n => {
                return {
                    code: n.fieldPath,
                    name: n.title
                };
            });

            if (!this.fields.length && this.searchFields.length) {
                this.fields = this.searchFields.map(n => {
                    return {
                        code: n.value,
                        name: n.label
                    }
                });
            }

            if (this.viewType === 'both' || this.viewType === 'onlyfield') {
                this.filterFields = this.columns.filter(n => n.fieldType && n.fieldType !== 'StringType' && n.fieldType !== 'TextType' && n.field).map(n => {
                    return this.converColumnToFilterField(n);
                });
            }

            if (this.lookIns && this.lookIns.allowQueryFields) {
                const { nav, main } = this.lookIns.allowQueryFields;
                let queryFields = main;
                if (this.isNav) {
                    queryFields = nav;
                }

                if (queryFields) {
                    const _queryFields = queryFields.split(',');
                    this.fields = this.fields.filter(n => _queryFields.findIndex(f => f === n.code) > -1);
                    this.filterFields = this.filterFields.filter(n => _queryFields.findIndex((f: any) => f === n.code) > -1);
                }
            }

            this.cd.markForCheck();
        }
    }

    onConditionChange($event, isString = true) {
        if (isString) {
            this.textConditions = $event;
        } else {
            this.fieldConditons = $event;
        }

        this.textConditions = this.textConditions || [];
        const _conditions$ =  this.fieldConditons.concat([]);
        if (this.fieldConditons && this.fieldConditons.length && this.textConditions.length) {
            _conditions$[0].lbracket =  this.fieldConditons[0].lbracket + '(';
            _conditions$[_conditions$.length - 1].relation = 1;
            _conditions$[_conditions$.length - 1].rbracket =  _conditions$[_conditions$.length - 1].rbracket + ')';
        }
        
        const _conditions = _conditions$.concat(this.textConditions);
        this.conditionsChange.emit(_conditions);
    }

    onClearConditions($event: MouseEvent) {
        $event.stopPropagation();
        this.textConditions = [];
        this.fieldConditons = [];


        if (this.searchboxRef) {
            this.searchboxRef.clearConditions(false);
        }

        if (this.searchfieldsRef) {
            this.filterFields.forEach(n => {
                n.value = null;
            });
            this.searchfieldsRef.clearConditions(false);
        }

        this.cd.detectChanges();
        this.conditionsChange.emit([]);
    }

    onEsc($event) {
        this.lookIns.closeLoading();
        this.lookIns.closeDialog();
    }
}